var _rect, _rect2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 9.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 9.5,
    stroke: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.782305, 0, 0, 1.729338, 9.216532, 11.107101)",
    style: {}
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.2143 0C5.7975 0 5.3978 0.16556 5.1031 0.46026C4.8084 0.75496 4.6428 1.1547 4.6428 1.5714V7.8571C4.6428 8.2739 4.8084 8.6736 5.1031 8.9683C5.3978 9.263 5.7975 9.4286 6.2143 9.4286H10.9285C11.3453 9.4286 11.745 9.263 12.0397 8.9683C12.3344 8.6736 12.5 8.2739 12.5 7.8571V3.4681C12.4999 3.0514 12.3343 2.6518 12.0395 2.3571L10.1428 0.46043C9.8482 0.16571 9.4486 0.00009 9.0318 0H6.2143Z",
    fill: "#7a7a7a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 4.7143C1.5 4.2975 1.6656 3.8978 1.9603 3.6031C2.255 3.3084 2.6547 3.1428 3.0714 3.1428V11H9.3571C9.3571 11.4167 9.1916 11.8164 8.8969 12.1111C8.6022 12.4058 8.2025 12.5714 7.7857 12.5714H3.0714C2.6547 12.5714 2.255 12.4058 1.9603 12.1111C1.6656 11.8164 1.5 11.4167 1.5 11V4.7143Z",
    fill: "#7a7a7a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.913f7fd6.svg";
export { ForwardRef as ReactComponent };